import React, { useState } from "react";
import { Box, Button, Typography, Fade } from "@mui/material";

import NotFoundImage from "../../../../assets/ilustrations/notfound.svg";

function NotFound({
  alt = "Página não encontrada",
  title = "Página não encontrada",
  description = "A página que você está tentando acessar não existe ou foi removida.",
  buttonText = "Voltar ao Painel",
  buttonHref = "/painel",
}) {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <Fade in={imageLoaded} timeout={500}>
      <Box
        sx={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: 2,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "500px",
            textAlign: "center",
          }}
        >
          <Box
            component="img"
            src={NotFoundImage}
            alt={alt}
            onLoad={() => setImageLoaded(true)}
            sx={{
              width: "100%",
              maxWidth: "600px",
              height: "auto",
              display: "block",
              margin: "0 auto",
            }}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              mt: 2,
            }}
          >
            <Typography
              fontWeight={700}
              sx={{
                fontSize: { xs: "18px", sm: "24px" },
                color: "#8033F4",
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "14px", sm: "16px" },
              }}
            >
              {description}
            </Typography>

            {buttonText && (
              <Button
                href={buttonHref}
                variant="contained"
                sx={{
                  mt: 2,
                  width: "100%",
                  maxWidth: "320px",
                  marginInline: "auto",
                }}
              >
                {buttonText}
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </Fade>
  );
}

export default NotFound;